<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm9 md6 lg4>
      <v-card class="LoginCard">
        <v-card-title primary-title class="LoginCard-title">
          <img src="/images/logo_text.png" alt="logo explorama" />
          <!--v-chip color="primary" class="white--text font-weight-bold betaChip" small>BETA</!--v-chip-->
          <p>{{ $t('login.subtitle') }}</p>
        </v-card-title>
        <v-form @submit.prevent="doLogin" id="LoginForm" ref="form">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  :label="$t('login.username')"
                  type="email"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="password"
                  :rules="passwordRules"
                  :label="$t('login.password')"
                  type="password"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-alert type="error" :value="errorMessage" outline>{{
                  translatedError
                }}</v-alert>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-flex md4>
            <v-btn flat small color="primary" href="/requestResetPassword">{{
              $t('login.resetPassword')
            }}</v-btn>
          </v-flex>
          <v-card-actions>
            <v-btn
              color="primary"
              form="LoginForm"
              outline
              class="LoginCard-LoginBtn"
              @click="$router.push('/accountCreation')"
              >{{ $t('login.createAccount') }}</v-btn
            >
            <v-btn
              color="primary"
              type="submit"
              form="LoginForm"
              class="LoginCard-LoginBtn"
              >{{ $t('login.submitLabel') }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>

    <loading-state :isLoading="isLoading"> </loading-state>
  </v-layout>
</template>

<script>
import LoadingState from '../components/LoadingState';

export default {
  name: 'loginPage',
  components: {
    LoadingState,
  },
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      emailRules: [
        (email) => Boolean(email) || this.$t('login.errors.emailRequired'),
        (email) =>
          /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/.test(
            email
          ) || this.$t('login.errors.emailInvalid'),
      ],
      passwordRules: [
        (password) =>
          Boolean(password) || this.$t('login.errors.passwordRequired'),
      ],
    };
  },
  computed: {
    translatedError() {
      if (this.errorMessage.match(/wrong.*username.*password/)) {
        return this.$t('login.errors.badCredentials');
      }
      if (this.errorMessage.match(/Missing.*credentials/)) {
        return this.$t('login.errors.missingCredentials');
      }
      if (this.errorMessage.match(/.*not connected to.*/)) {
        return this.$t('login.errors.notConnected');
      }
      return this.$t('login.errors.generic');
    },
    isLoading() {
      return this.$store.getters['app/isLoading'];
    },
  },
  methods: {
    async doLogin() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const credentials = { username: this.email, password: this.password };
      this.setErrorMessage('');

      await this.$store.commit('app/SET_LOADING');

      await this.$store
        .dispatch('auth/LOGIN', { credentials, kuzzle: this.$kuzzle })
        .then(() => {
          if (this.$route.query.to) {
            this.$router.push({ name: this.$route.query.to });
          }
          this.$router.push('/');
        })
        .catch((error) => {
          this.isLoading = false;
          console.error(error.message);
          this.setErrorMessage(error.message);
        });
      await this.$store.commit('app/UNSET_LOADING');
    },
    setErrorMessage(errorMessage) {
      this.errorMessage = errorMessage;
    },
  },
};
</script>

<style scoped lang="sass">
.LoginCard
  &-title
    img
      width: 25em
      margin-bottom: 2em
  &-LoginBtn
    margin: 0
  .betaChip
    margin-left: 15px
    margin-bottom: 20px
    border-radius: 5px
</style>
